import { type DetailedHTMLProps, type HTMLAttributes } from 'react'
import { cn } from '#app/utils/misc.js'

export default function MarketingSpacer({
	side = 'both',
	hideOnMobile = false,
	...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	side?: 'both' | 'top' | 'bottom'
	hideOnMobile?: boolean
}) {
	const classes = cn(
		'block h-px w-full bg-transparent',
		hideOnMobile && 'hidden sm:block',
		side === 'both' &&
			'my-xl sm:my-md md:my-xl lg:my-xxxl xl:my-[100px] 2xl:my-[140px]',
		side === 'top' &&
			'mt-xl sm:mt-md md:mt-xl lg:mt-xxxl xl:mt-[100px] 2xl:mt-[140px]',
		side === 'bottom' &&
			'mb-xl sm:mb-md md:mb-xl lg:mb-xxxl xl:mb-[100px] 2xl:mb-[140px]',
		props.className,
	)

	return <div {...props} className={classes} />
}
